import React from 'react';
import { Link } from 'react-router-dom';
import posts from './posts';
import usePageMeta from './usePageMeta';
import PostTile, { Cover, formatDate } from './PostTile';

function BlogIndex() {
  usePageMeta(
    'Blog | Oneshoo',
    'Notes from the Oneshoo studio on what we are building and why.'
  );

  const [featured, ...rest] = posts;

  return (
    <div className="blog-index">
      <header className="blog-head">
        <div className="container">
          <span className="eyebrow">Blog</span>
          <h1>Notes from the studio</h1>
          <p className="section-sub">
            What we&apos;re building, how it&apos;s going, and the stories
            behind it.
          </p>
        </div>
      </header>

      <div className="container">
        <Link className="post-featured" to={`/blog/${featured.slug}`}>
          <div className="post-tile-img">
            {featured.cover && <Cover post={featured} eager />}
          </div>
          <div>
            <span className="post-date">{formatDate(featured.date)}</span>
            {featured.draft && <span className="draft-badge">Draft</span>}
            <h2>{featured.title}</h2>
            <p>{featured.excerpt}</p>
            <span className="read-more">Read post →</span>
          </div>
        </Link>

        <div className="post-grid">
          {rest.map((post) => (
            <PostTile key={post.slug} post={post} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default BlogIndex;
